import { render, staticRenderFns } from "./SearchCoords.vue?vue&type=template&id=6ae76537&scoped=true"
import script from "./SearchCoords.vue?vue&type=script&lang=js"
export * from "./SearchCoords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae76537",
  null
  
)

export default component.exports